module.exports = __webpack_public_path__ + "img/software_centerbase.44ec20cd.jpg";